module.exports = __webpack_public_path__ + "static/media/user-times.b7919c56.svg";